import titleAndDescription from './TitleAndDescription';
import callouts from './Callouts';
import detailCharts from './DetailCharts';

export default [titleAndDescription, callouts, detailCharts];
